import _ from 'lodash'
import moment from 'moment'
import { AxiosRequestConfig } from 'axios'
import React from 'react'
import { notification, Button } from 'antd'
import { http, udConfigProvider, uaaApp, routeUtils } from '@ud/admin-framework'
import { appStore } from './stores/appStore'
import { IMyUserData } from './typings'
import { uaaRoutes } from './config/uaaRoutes'
import { bizLibraryConfig } from '@ud/biz-library'

class UaaCenter {

  public code: string = 'uaa'
  public options: IUaaCenterOptions = {} as any

  public run(options: IUaaCenterOptions) {
    this.options = options
    this.configBase()
    let qs = this.getQsParams()
    if (qs.login) {
      appStore.removeToekn()
      appStore.myUserData = null as any
      options.render()
    } else {
      let token = appStore.getToken()
      if (token) {
        const time = moment().valueOf()
        http.post<IMyUserData>(`/my/info?ts=${time}`).then(res => {
          appStore.myUserData = res.data
          bizLibraryConfig.start({
            urls: res.data.urls || {}
          })
          this.configMenuAndRoute()
          this.runTokenRefresher()
          // 本地开发测试
          if (process.env.REACT_APP_ENV == 'local') {
            (window as any)['myUserData'] = res.data // 方便开发调试。

            // appStore.myUserData.webUrls['BIZ-INFRA-MANAGE-OPENAPI'] = 'http://localhost:3000/'
            appStore.myUserData.webUrls['cloud-crm'] = 'http://localhost:8343/'
            appStore.myUserData.webUrls['STOCK'] = 'http://localhost:3002/'
            appStore.myUserData.webUrls['WORK-ORDER'] = 'http://localhost:8080/'
            appStore.myUserData.webUrls['MY-FILE'] = 'http://localhost:3500/'
            appStore.myUserData.webUrls['MY-FLOW'] = 'http://localhost:3500/'
            appStore.myUserData.webUrls['smart-cabinet'] = 'http://localhost:3001/'
          }
        }, res => {
          appStore.removeToekn()
        }).finally(() => {
          options.render()
        })
      } else {
        appStore.myUserData = null as any
        options.render()
      }
    }
  }

  private getQsParams = () => {
    return routeUtils.searchStringToObject(window.location.search, { login: false })
  }

  public refreshToken = (callback?: (data: any) => void) => {
    let token = appStore.getToken()
    if (token) {
      if (moment(token.refreshTokenExpireTime).unix() > moment().unix()) {
        http.post('/token/refresh', {
          accessToken: token.accessToken,
          refreshToken: token.refreshToken
        }).then(res => {
          appStore.setToken(res.data)
          if (callback) {
            callback(res.data)
          }
        })
      }
    } else {
      this.show401Error()
    }
  }

  public setLastVisitUrl = (url: string) => {
    sessionStorage.setItem('uaa_last_visit_url', url)
  }

  public getLastVisit = () => {
    let url = sessionStorage.getItem('uaa_last_visit_url')
    if (!url) {
      return
    }
    let systemCode = this.findSystemCodeByUrl(url)
    return { url, systemCode }
  }

  public findSystemCodeByUrl = (targetUrl: string) => {
    let target = new URL(targetUrl)
    for (const key in appStore.myUserData.webUrls) {
      let url = appStore.myUserData.webUrls[key]
      if (!url) {
        console.error(`${key} 系统未配置 前端访问url。`)
        continue
      }
      try {
        let current = new URL(url)
        if (target.protocol == current.protocol && target.host == current.host) {
          return key
        }
      }
      catch { console.warn('错误的 url:' + url) }
    }
    return
  }

  private configBase() {
    uaaApp.appCode = this.code
    http.defaults.baseURL = this.options.baseURL
    udConfigProvider.api.useConditionsField = false
    udConfigProvider.http.requestBeforeSetToken = (config: AxiosRequestConfig) => {
      let token = appStore.getToken()
      if (token) {
        config.headers['Authorization'] = token.accessToken
      }
      return config
    }
    udConfigProvider.ui.table.watermark.text = () => appStore.myUserData.profile.jobNumber
    udConfigProvider.http.errorHandler[401] = this.show401Error
  }

  private configMenuAndRoute() {
    let system = appStore.getSystem(this.code)
    if (system) {
      if (process.env.REACT_APP_ENV == 'local') {
        uaaApp.options.local = {
          useLocalMenu: false,
          menus: [],
          apiBaseUrl: this.options.baseURL,
          loginApiBaseUrl: this.options.baseURL
        }
      }
      appStore.uaaAppName = system.text
      uaaApp.routes = uaaRoutes
      uaaApp.processRoutes(uaaApp.routes)
      appStore.uaaRouteNodes = routeUtils.buildRouteNodes(uaaApp.routes)
      if (system.items) {
        uaaApp.options.autoMapMenu = true
        appStore.uaaMenus = uaaApp.transformMenus(system.items)
      }
    }
  }

  private runTokenRefresher = () => {
    setInterval(() => { this.refreshToken() }, 10 * 60 * 1000)
  }

  private show401Error = () => {
    notification.error({
      message: '登录超时',
      description: <div style={{ display: 'flex', alignItems: 'center' }}>
        <span style={{ flex: '1' }}>请点击退出按钮后重新登录。</span>
        <Button type="primary" style={{ fontSize: '12px' }} size="small" onClick={() => appStore.logout()}>退出</Button>
      </div>
    })
  }
}

export interface IUaaCenterOptions {
  baseURL: string
  render: () => void
}

let uaaCenter = new UaaCenter()

export { uaaCenter }
